export default "__VITE_ASSET__DtiJNy5D__"